var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'flex items-center justify-center text-primary',
        _vm.inlined ? 'flex-row' : 'flex-col',
    ]},[(_vm.darkMode)?_c('WhiteText'):_vm._e(),(!_vm.darkMode)?_c('BlackText'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }